import React from "react";

export default function Footer() {
  return (
    <footer>
      <a
        href="https://github.com/reeserosedesign/dictionary"
        target="_blank"
        rel="noreferrer"
      >
        open source code
      </a>{" "}
      by{" "}
      <a
        href="https://www.reeserosedesign.com"
        target="_blank"
        rel="noreferrer"
      >
        reese rose
      </a>
    </footer>
  );
}
